/**
 * Keyframes the call surface needs, injected by the call surface.
 *
 * `styles.css` is the app's shared design system and is owned elsewhere; these
 * five animations exist only while somebody is in a call and would be dead
 * bytes on every other screen. Rendering them from here keeps them next to the
 * components that use them and out of the global sheet.
 *
 * Everything is wrapped in `@media (prefers-reduced-motion: no-preference)` so
 * the app's existing reduced-motion rule is not something this has to be
 * remembered to respect — with the preference set, none of these exist at all.
 */

const CSS = `
@media (prefers-reduced-motion: no-preference) {
  @keyframes era-menu {
    from { opacity: 0; transform: translateY(6px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0)   scale(1); }
  }
  @keyframes era-tile-in {
    from { opacity: 0; transform: scale(0.94); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes era-toast-in {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes era-sheen {
    from { transform: translateX(-120%); }
    to   { transform: translateX(220%); }
  }
  @keyframes era-orbit {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
}
`

/**
 * `href` + `precedence` are React 19's stylesheet de-duplication: the element
 * may be rendered by the lobby and by the call at the same time, and React
 * hoists exactly one copy into `<head>`. Without them, navigating between the
 * two would stack identical `<style>` tags.
 */
export function CallKeyframes() {
  return (
    <style href="era-call-keyframes" precedence="default">
      {CSS}
    </style>
  )
}
